import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

interface Props {
  show: boolean;
  onContinuar: () => void;
  onCriarNovo: () => void;
  onCancel: () => void;
}

const MDFeModalNovoView = ({
  show,
  onContinuar,
  onCriarNovo,
  onCancel,
}: Props) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      className="modal-content-question"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-primary">
          <FontAwesomeIcon icon={faQuestionCircle} /> MDF-e em Andamento
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Foi encontrado um MDF-e em andamento salvo no armazenamento do navegador.
        </p>
        <p className="mb-0 text-muted">
          Deseja continuar editando o MDF-e existente ou deseja iniciar um novo cadastro do zero?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          className="messagebox-btn-ok"
          onClick={onContinuar}
        >
          Continuar Editando
        </Button>
        <Button
          variant="outline-primary"
          className="messagebox-btn-cancel"
          onClick={onCriarNovo}
        >
          Criar Novo
        </Button>
        <Button
          variant="outline-danger"
          className="messagebox-btn-cancel"
          onClick={onCancel}
        >
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MDFeModalNovoView;
